class ConsoleTransport {
    formatter;
    // oxlint-disable-next-line typescript/parameter-properties
    constructor(formatter) {
        this.formatter = formatter;
    }
    write(appLog) {
        const log = this.formatter.format(appLog);
        switch (appLog.level) {
            case 'fatal':
            case 'error':
                console.error(log);
                return;
            case 'warning':
                console.warn(log);
                return;
            case 'info':
                console.info(log);
                return;
            case 'debug':
                console.debug(log);
                return;
            default:
                // oxlint-disable-next-line no-console
                console.log(log);
        }
    }
}

export { ConsoleTransport };
//# sourceMappingURL=ConsoleTransport.js.map
